<main class="d-flex flex-nowrap">
  <app-sidebar
    id="main-sidebar"
    class="main-sidebar d-flex flex-column ps-3 pe-4"
    [mode]="mode"
    [sidebarWidth]="sidebarWidth"
  ></app-sidebar>
  <div class="main-sidebar-resize-handle d-flex align-items-center" appResizeHandle [(width)]="sidebarWidth" [min]="160" [max]="600">
    <fa-icon icon="grip-lines-vertical" size="lg"></fa-icon>
  </div>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</main>
<!--
  <div class="flex-grow-1" >
    <div class="drag-detector drag-top-detector" (dragenter)="dragEnterDetector($event, +1)" (dragleave)="dragExitDetector($event)"></div>

    <div
      class="drag-detector drag-bottom-detector"
      (dragenter)="dragEnterDetector($event, -1)"
      (dragleave)="dragExitDetector($event)"
    ></div>
  </div>
-->
